import { createContext, useContext, type ReactNode } from "react";
import { useChatSocket, type ChatConnectionState } from "../hooks/useChatSocket";
import type { ChatMessageDTO } from "@jaiho/shared";

interface ChatContextValue {
  connectionState: ChatConnectionState;
  messages: ChatMessageDTO[];
  presenceCount: number;
  sendMessage: (body: string) => void;
}

const ChatContext = createContext<ChatContextValue | null>(null);

/**
 * Connects once to the global lobby DO for the whole authenticated session,
 * so both the Home screen (online count) and the Chat screen (full
 * conversation) share a single WebSocket instead of opening one each.
 */
export function ChatProvider({ enabled, children }: { enabled: boolean; children: ReactNode }) {
  const value = useChatSocket(enabled);
  return <ChatContext.Provider value={value}>{children}</ChatContext.Provider>;
}

export function useChat(): ChatContextValue {
  const ctx = useContext(ChatContext);
  if (!ctx) throw new Error("useChat must be used within a ChatProvider");
  return ctx;
}
